import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";

const DeleteDialog = ({ deleteDialog, setDeleteDialog, handleDeleteIban }) => {
  const handleClose = () => {
    setDeleteDialog(false);
  };
  const handleApprove = () => {
    handleDeleteIban();
    setDeleteDialog(false);
  };

  return (
    <Dialog
      open={deleteDialog}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Kayıtlı hesabınızı silmek üzeresiniz. Bu işleme devam etmek
          istediğinize emin misiniz?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button className="iyzi-button-blue" onClick={handleClose}>
          Hayır
        </Button>
        <Button className="iyzi-button-red" onClick={handleApprove} autoFocus>
          Evet
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteDialog;
